const CATEGORY_COLORS: Record<number, string> = {
    1: "#40b34e",   // SUPER OPEN
    2: "#69707c",   // OPEN
    3: "#6d5fc5",   // RACER
    4: "#c59e01",   // RACER CRUISER
    5: "#80deea",   // CRUISER LEHKÝ
    6: "#469fe6",   // CRUISER STŘEDNÍ
    7: "#e89557",   // CRUISER TĚŽKÝ
};

const DEFAULT_CATEGORY_COLOR = '#bdbdbd'; // default color if no category matches

export function getCategoryColor(id: number): string {
    return CATEGORY_COLORS[id] ?? DEFAULT_CATEGORY_COLOR;
}
